import { Component, OnInit } from '@angular/core';

import { ActivatedRoute } from "@angular/router";
import { environment } from "../../../../environments/environment";
import {AuthService} from "../../services";
import {PermissionFlagsService} from "../../services/permissionFlags.service";


@Component({
  selector: 'app-authentication',
  standalone: true,
  imports: [],
  templateUrl: './authentication.component.html',
  styleUrl: './authentication.component.css'
})
export class AuthenticationComponent implements OnInit {
  PORTAL = `${environment.PORTAL}`;

  constructor(
      private authService: AuthService,
      private permissionFlag: PermissionFlagsService,
      private route: ActivatedRoute
  ) {
  }

  ngOnInit(): void {
    this.autoLogin();
  }

  private autoLogin(): void {
    const authKey = this.route.snapshot.queryParamMap.get('auth-key');

    if (!authKey) {
      console.error('No auth-key found');
      window.location.href = this.PORTAL;
      return;
    }

    this.authService.login(authKey).subscribe({
      next: (isLoggedIn) => {
        if (!isLoggedIn) return;
        this.permissionFlag.refreshPermissions().subscribe({
          next: () => this.authService.homePage(),
          error: () => this.authService.homePage()
        });
      },
      error: (error) => {
        console.error('Login failed', error);
        window.location.href = this.PORTAL;
      }
    });
  }
}
